import { gql } from 'apollo-angular';

const REMOVE_ORGANIZATIONS_FROM_HIERARCHY = gql`
  mutation AdminRemoveOrganizationMembers(
    $removeMembersRequest: AddRemoveGroupMembersRequest!
  ) {
    removeMembers(removeMembersRequest: $removeMembersRequest) {
      id
      name
      organizationHirerachy {
        children {
          id
          name
        }
      }
    }
  }
`;

export default REMOVE_ORGANIZATIONS_FROM_HIERARCHY;
